import React, {
  useState,
  useEffect
} from 'react';
import './style.scss';
import '../../../utils/md-toc.js'
import { useRouteMatch } from 'react-router-dom';
import { useAliyunOffice } from '../../../hooks/aliyun.js';
import { getItemByUrl } from '../../../utils/index.js';

const CoursePPT = () => {
  const match = useRouteMatch();
  
  const [pptFurl, setPptFurl] = useState('')
  useEffect(() => {
    const id = match.params.id
    // const video = JSON.parse(localStorage.getItem('CoursePPT'))
    const video = getItemByUrl('CoursePPT')
    if (video && video[id]) {
      setPptFurl(video[id])
    }
  }, [match.params.id])
  // const obj = JSON.parse(sessionStorage.getItem('aliyun'))
  const obj = getItemByUrl('aliyun', sessionStorage)
  const {isAliyun, checkAliyunSdk, setLastTokenInfo } = useAliyunOffice(
    (obj && obj.currentUnitId) || null, (obj && obj.id) || null
  ) || {}
  useEffect(() => {
    let sectionCourse
    // const obj = JSON.parse(sessionStorage.getItem('aliyun'))
    const obj = getItemByUrl('aliyun', sessionStorage)
    if (obj) {
      sectionCourse = obj
      if (!sectionCourse.is_series) {
        setLastTokenInfo(sectionCourse.aliyun_token_info);
        checkAliyunSdk('#aliyun-play-container', 0, sectionCourse?.is_aliyun_ppt && sectionCourse?.ppt_furl && 
        !sectionCourse?.ppt_furl.endsWith('.mp4'), false)
      } else {
        // 系列课程请求ppt数据
        let target = sectionCourse.units.find(
          item => item.id === Number(sectionCourse.currentUnitId)
        );
        checkAliyunSdk('#aliyun-play-container', Number(sectionCourse.currentUnitId), sectionCourse?.is_aliyun_ppt && target?.ppt_furl && !target?.ppt_furl.endsWith('.mp4'), true)
      }
    }
  }, [])
  useEffect(() => {
    // const obj = JSON.parse(sessionStorage.getItem('aliyun'))
    const obj = getItemByUrl('aliyun', sessionStorage)
    const handleSender = () => {
      // 通知 opener（父窗口）说我要关闭了
      if (window.opener) {
        window.opener.postMessage('child_window_closed', '*');
      }
    }
    if (obj?.is_aliyun_ppt) {
      window.addEventListener('beforeunload', handleSender);
    }
    return () => {
      window.removeEventListener('beforeunload', handleSender);
    }
  }, [])
  return (
    <div id="CoursePPT">
      {
      isAliyun === false && <iframe
        title="pptIframe"
        className="iframe"
        src={pptFurl}
        style={
          {
            borderRadius: '7px'
          }
        }
        allowFullScreen
        allow="fullscreen"
      >
      </iframe>
    }
    {
      isAliyun === true && <div id="aliyun-play-container"></div>
    }
    </div>
  )

};

export default CoursePPT;
